import { cs } from 'date-fns/locale'

export default defineAppConfig({
  locale: cs,
  currency: 'CZK',
  platformName: 'skupinaklik.cz',
})
